import { useMemo } from 'react'
import { clsx } from 'clsx'
import { sortBy } from 'lodash'
import PropTypes from 'prop-types'
import SelectAic from '../../shared/components/selectAic'
import { InViewSimpleTransition } from '../../shared/utils/animations/transitions'

const MobileTimelineControls = ({ options, selectedOption, setSelectedOption }) => {
  // const { options, selectedOption, setSelectedOption } = props
  const selectOptions = useMemo(() => {
    const groupedIptions = [...new Set(options.map((item) => item.year))]
    return groupedIptions
      .map((item) => {
        const _options = options
          .filter((x) => x.year === item && x.id !== null)
          .map((x) => {
            return {
              value: x.id,
              label: `${String(x.eventTitle).toUpperCase()}`,
              isDisabled: x.id == null,
              date: x?.date,
            }
          })
        return {
          label: item,
          options: sortBy(_options, ['date']),
          isDisabled: _options.length === 0,
        }
      })
      .filter((item) => item.options.length > 0)
  }, [options])

  const defaultOption = useMemo(
    () =>
      selectOptions
        .filter((x) => x.label === selectedOption.year)
        .map((x) => x.options)
        .flat()
        .find((x) => x.value === selectedOption.id),
    [options, selectedOption],
  )

  //   console.log(selectOptions)
  const customStyles = {
    control: () => {
      return clsx(`px-[15px] py-[15px] leading-normal
              !rounded-[37px] !border !border-[1px] !border-eerie-black
              md:w-full !bg-isabelline
              hover:!border-eerie-black-dark
               `)
    },
    indicatorSeparator: () => '!hidden',
    dropdownIndicator: () => '!text-eerie-black-dark !font-[400]',
    listBox: () => `!rounded-[20px] !p-0 !m-0`,
    menu: () => `!rounded-[20px] !text-[20px]`,
    menuList: () => `!rounded-[20px] !p-0 !m-0`,
  }
  return (
    <InViewSimpleTransition
      className="col-span-12 z-20 mt-5"
      type={'fade'}
      parent={null}
      slide_direction={'right'}
    >
      <SelectAic
        value={defaultOption}
        onChange={(value) => {
          setSelectedOption(value?.value)
        }}
        className=""
        options={selectOptions}
        classNames={customStyles}
      />
    </InViewSimpleTransition>
  )
}

MobileTimelineControls.propTypes = {
  options: PropTypes.array,
  selectedOption: PropTypes.string,
  setSelectedOption: PropTypes.func,
}

export default MobileTimelineControls
